﻿import config from "../config"
const baseUrl = config.base_url + "lz_garden_worker/"
export default {
    page: {
        url: baseUrl + "page/{limit}/{page}",
        type: "post",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    remove: {
        url: baseUrl + "delete",
        type: "get",
    }
}

